import React, { memo } from "react";
import { UiCenter, UiSpinner } from ".";

interface Props {
  text?: string;
}

export const UiPageLoading = memo(({ text = "Loading" }: Props) => (
  <UiCenter height="100vh">
    <UiSpinner size="xl" label={text} />
  </UiCenter>
));
